import React from 'react'
import Reach from './Reach'
import '../Contact/Contactus.css'
import Poc from './Poc'

const Contactus = () => {
  return (
    <>
     <Poc/>
        <Reach/>
        <section className="map-section">
      <div className="map-container">
       
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d224345.8979633909!2d77.04416717106561!3d28.527554412293725!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cfd5b347eb62d%3A0x52c2b7494e204dce!2sNew%20Delhi%2C%20Delhi!5e0!3m2!1sen!2sin!4v1736321808116!5m2!1sen!2sin"
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </div>
    </section>
    </>
  )
}

export default Contactus